import customization from './customization';
import siteCustomization from './site-customization';
import currentTheme from './current-theme';

export default {
  customization,
  siteCustomization,
  currentTheme,
};
